/*
 * Файлы артов в apps/client/public/art.
 *
 * Ширины — общие для клиента (srcset) и проверки в tools: строка CSV
 * без файла нужной ширины ломает сборку, а не карточку у игрока.
 */
/** Подготовленный арт коллекционной карты 3:5, без полей. */
export const CARD_ART_WIDTHS = [360, 720];
export const cardArtBase = (art) => `/art/cards/${art}`;
/** `/art/x` + [360, 720] → `/art/x-360.webp 360w, /art/x-720.webp 720w`. */
export function artSrcSet(base, widths) {
    return widths.map((w) => `${base}-${w}.webp ${w}w`).join(', ');
}
/** Все файлы одного арта: для проверки, что они лежат на месте. */
export function artFiles(base, widths) {
    return widths.map((w) => `${base}-${w}.webp`);
}
//# sourceMappingURL=art.js.map